import { render, staticRenderFns } from "./UtteranceControl.vue?vue&type=template&id=4afe3395&scoped=true&"
import script from "./UtteranceControl.vue?vue&type=script&lang=ts&"
export * from "./UtteranceControl.vue?vue&type=script&lang=ts&"
import style0 from "./UtteranceControl.vue?vue&type=style&index=0&id=4afe3395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe3395",
  null
  
)

export default component.exports